import { Action, createReducer, on } from '@ngrx/store';

import { Customer } from './customer.models';
import { AuthorizationCustomerActions, AuthorizationCustomerApiActions } from './customer.actions';

export interface CustomerState {
  entity: Customer | null;
  loading: boolean;
}

export const initialState: CustomerState = {
  entity: null,
  loading: false,
};

const customerReducer = createReducer(
  initialState,
  on(
    AuthorizationCustomerActions.load,
    (state): CustomerState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AuthorizationCustomerActions.update,
    (state): CustomerState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    AuthorizationCustomerActions.clear,
    (state): CustomerState => ({
      ...state,
      entity: null,
    })
  ),
  on(
    AuthorizationCustomerActions.loadFromRegisterAPI,
    (state, { customer }): CustomerState => ({
      ...state,
      entity: customer,
      loading: false,
    })
  ),
  on(
    AuthorizationCustomerApiActions.loadSuccess,
    (state, { customer }): CustomerState => ({
      ...state,
      entity: customer,
      loading: false,
    })
  ),
  on(
    AuthorizationCustomerApiActions.loadFailure,
    (state): CustomerState => ({
      ...state,
      loading: false,
    })
  ),
  on(
    AuthorizationCustomerApiActions.updateSuccess,
    (state, { customer }): CustomerState => ({
      ...state,
      entity: customer,
      loading: false,
    })
  ),
  on(
    AuthorizationCustomerApiActions.updateFailure,
    (state): CustomerState => ({
      ...state,
      loading: false,
    })
  )
);

export function reducer(state: CustomerState | undefined, action: Action) {
  return customerReducer(state, action);
}
